import { isDevelopment, isUnitTesting } from "core/utils";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { Languages } from "./constants";
import de from "./de.yaml";
import en from "./en.yaml";
import fr from "./fr.yaml";

const resources = {
    en: { translation: en },
    fr: { translation: fr },
    de: { translation: de },
};

export const initTranslations = () => {
    return i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            fallbackLng: Languages.en,
            debug: false,
            resources,
            supportedLngs: Object.values(Languages),

            interpolation: {
                escapeValue: false, // React already protects from XSS
            },

            parseMissingKeyHandler: (key, defaultValue) => {
                if (isUnitTesting()) {
                    return key;
                }

                if (isDevelopment()) {
                    // console.warn(`Missing key: ${key}`);
                }

                return defaultValue ?? `${key}`;
            },
        });
};

/**
 * Sets language with improved error handling
 */
export const setLanguage = (language: Languages) => {
    if (Object.values(Languages).includes(language)) {
        i18n.changeLanguage(language).catch(() => {
            // Fallback to English if language change fails
            i18n.changeLanguage(Languages.en);
        });
    } else {
        i18n.changeLanguage(Languages.en);
    }
};
